import { render, staticRenderFns } from "./BaseModalTitle.vue?vue&type=template&id=3dcb81e7&scoped=true"
import script from "./BaseModalTitle.vue?vue&type=script&lang=js"
export * from "./BaseModalTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseModalTitle.vue?vue&type=style&index=0&id=3dcb81e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb81e7",
  null
  
)

export default component.exports